var map = {
	"./BCH.png": "55d5",
	"./BTC.png": "3779",
	"./ETH.png": "9b8b",
	"./LTC.png": "1abc",
	"./TRX.png": "b623",
	"./USDTE.png": "01eb",
	"./USDTT.png": "e05a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f637";